import { DesktopPanelDocumentModelIdoCategories } from 'src/models/document';

type DocumentCategoriesCommandPayloadEntry = {
	categoryId: null | string;
	idoId: number;
	idoInstanceId: number;
};

export function selectedCategoryIdForIdoGroup(group: DesktopPanelDocumentModelIdoCategories): null | string {
	const selectedCategory = group.desktopPanelDocumentModelCategories.find(
		(category) => category.isTheSelectedCategoryForTheDocument
	);

	return selectedCategory === undefined ? null : String(selectedCategory.id);
}

export function withSelectedCategory(
	groups: DesktopPanelDocumentModelIdoCategories[],
	idoId: number,
	idoInstanceId: number,
	categoryId: string
): DesktopPanelDocumentModelIdoCategories[] {
	return groups.map((group) => {
		if (group.idoId !== idoId || group.idoInstanceId !== idoInstanceId) {
			return group;
		}

		return {
			...group,
			desktopPanelDocumentModelCategories: group.desktopPanelDocumentModelCategories.map((category) => ({
				...category,
				isTheSelectedCategoryForTheDocument: String(category.id) === categoryId,
			})),
		};
	});
}

export function buildDocumentCategoriesCommandPayload(
	groups: DesktopPanelDocumentModelIdoCategories[]
): DocumentCategoriesCommandPayloadEntry[] {
	return groups.map((group) => ({
		categoryId: selectedCategoryIdForIdoGroup(group),
		idoId: group.idoId,
		idoInstanceId: group.idoInstanceId,
	}));
}
